import type { ConceptEntity, EntityRole } from '@/types/knowledge_graph'
import { EntityCard } from '../components/EntityCard'

interface Props {
  entities: ConceptEntity[]
  entityRoleLabels: Partial<Record<EntityRole, string>>
  onUpdateEntity: (entityId: string, changes: Partial<ConceptEntity>) => void
}

function groupCols (count: number): number {
  return Math.min(count, 4)
}

export function ConceptsTab ({ entities, entityRoleLabels, onUpdateEntity }: Props): React.ReactElement {
  const actors = entities.filter((e) => e.entity_role === 'actor')
  const resources = entities.filter((e) => e.entity_role === 'resource')
  const events = entities.filter((e) => e.entity_role === 'event')
  const unknowns = entities.filter((e) => e.entity_role === 'unknown')

  return (
    <div>
      <div>
        <div className='section-head'>
          <h3>エンティティ</h3>
          <span className='count'>{entities.length}件検出</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
          {actors.length > 0 && (
            <>
              <div style={{
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: '.06em',
                textTransform: 'uppercase',
                color: 'var(--bp-ok)',
                marginBottom: 2
              }}
              >
                {entityRoleLabels.actor ?? 'アクター'}（{actors.length}）
              </div>
              <div style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${groupCols(actors.length)},1fr)`,
                gap: 8
              }}
              >
                {actors.map((e) => (
                  <EntityCard
                    key={e.id}
                    entity={e}
                    roleLabels={entityRoleLabels}
                    onUpdate={(changes) => onUpdateEntity(e.id, changes)}
                  />
                ))}
              </div>
            </>
          )}
          {resources.length > 0 && (
            <>
              <div style={{
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: '.06em',
                textTransform: 'uppercase',
                color: 'var(--bp-accent)',
                marginBottom: 2
              }}
              >
                {entityRoleLabels.resource ?? 'リソース'}（{resources.length}）
              </div>
              <div style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${groupCols(resources.length)},1fr)`,
                gap: 8
              }}
              >
                {resources.map((e) => (
                  <EntityCard
                    key={e.id}
                    entity={e}
                    roleLabels={entityRoleLabels}
                    onUpdate={(changes) => onUpdateEntity(e.id, changes)}
                  />
                ))}
              </div>
            </>
          )}
          {events.length > 0 && (
            <>
              <div style={{
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: '.06em',
                textTransform: 'uppercase',
                color: 'var(--bp-warning)',
                margin: '8px 0 2px'
              }}
              >
                {entityRoleLabels.event ?? 'イベント'}（{events.length}）
              </div>
              <div style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${groupCols(events.length)},1fr)`,
                gap: 8
              }}
              >
                {events.map((e) => (
                  <EntityCard
                    key={e.id}
                    entity={e}
                    roleLabels={entityRoleLabels}
                    onUpdate={(changes) => onUpdateEntity(e.id, changes)}
                  />
                ))}
              </div>
            </>
          )}
          {unknowns.length > 0 && (
            <>
              <div style={{
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: '.06em',
                textTransform: 'uppercase',
                color: 'var(--bp-ink3)',
                margin: '8px 0 2px'
              }}
              >
                {entityRoleLabels.unknown ?? '未分類'}（{unknowns.length}）
              </div>
              <div style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${groupCols(unknowns.length)},1fr)`,
                gap: 8
              }}
              >
                {unknowns.map((e) => (
                  <EntityCard
                    key={e.id}
                    entity={e}
                    roleLabels={entityRoleLabels}
                    onUpdate={(changes) => onUpdateEntity(e.id, changes)}
                  />
                ))}
              </div>
            </>
          )}
          {entities.length === 0 && (
            <div style={{ color: 'var(--bp-ink3)', fontSize: 13 }}>エンティティがありません</div>
          )}
        </div>
      </div>
    </div>
  )
}
